import { Injectable, inject } from '@angular/core';
import { IViewModel } from '@shared/model/view-model';
import { StatisticsService } from '../http_services/statistics.service';
import { ViewSourceEnum } from '@shared/model/enum/view-source-enum';
import { Observable, of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ViewTrackerService {
  private statisticsService = inject(StatisticsService);

  private viewedIds = new Set<string>();
  private viewQueue: IViewModel[] = [];
  private readonly VIEW_COUNT_LIMIT = 10;

  //? Adds a view if it hasnt been sent before
  public markAsViewed(item: IViewModel): void {
    // Unique key by ID and source
    const uniqueKey = `${item.objectId}_${item.source}`;

    if (this.viewedIds.has(uniqueKey)) return;

    this.viewedIds.add(uniqueKey);
    this.viewQueue.push(item);

    // Send if from Detail or queue is full
    if (item.source === ViewSourceEnum.Detail || this.viewQueue.length === this.VIEW_COUNT_LIMIT) {
      this.submitQueuedViews().subscribe();
    }
  }

  //? Sends viewQueue to api
  public submitQueuedViews(): Observable<null | void> {
    if (this.viewQueue.length === 0) {
      return of(null);
    };

    const toSend = [...this.viewQueue];
    this.viewQueue = [];

    return this.postViews(toSend);
  }

  private postViews(item: IViewModel[]) {
    return this.statisticsService.viewCount(item);
  }

}
